<div class="main-page">

    <div class="container">

        <div class="setting-text-area">

            <div class="innerPage setting-text-area-inner">

                <div class="pg-header">
                    <div class="pg-heading">
                        <div class="pg-title">Analytics</div>
                        <div class="pg-subtitle">
                            Track your business performance and engagement.
                        </div>
                    </div>
                </div>

                <div *ngIf="!analyticsEnabled" class="locked-card">
                    <i class="fas fa-lock"></i>
                    <h3>Analytics Locked</h3>
                    <p>{{ analyticsMessage }}</p>
                    <button [routerLink]="['/mysubscration']" [queryParams]="{ isSub: true }">
                        Upgrade to Marketplace Pro
                    </button>
                </div>

                <div class="analytics-grid" *ngIf="analyticsEnabled">
                    <div class="analytics-card" *ngFor="let item of analyticsCards">
                        <div class="analytics-icon" [style.background]="item.color">
                            <i [class]="item.icon"></i>
                        </div>
                        <div class="analytics-content">
                            <div class="analytics-title">{{item.title}}</div>
                            <div class="analytics-value">{{item.value | number}}</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>